import React from 'react';
import {Device} from './shared.js';


export default () => {
  const color = '#FFF'
  const position = {
    bottom: 45,
    left: '15vw',
  }
  if (Device.isDesktopSmall() && !Device.isDesktopLarge()) {
    position.left = 45;
  }
  if (Device.isTablet()) {
    position.left = 45;
  }
  if (Device.isMobile()) {
    position.left = 15;
    position.bottom = 75;
  }
  const style = {
    logo: {
      position: 'absolute',
      bottom: position.bottom,
      left: position.left,
    },
    name: {
      color: color,
      fontSize: Device.isMobile() ? 44 : 70,
      fontWeight: '300',
      display: 'block',
    },
    title: {
      color: color,
      fontSize: Device.isMobile() ? 15 : 24,
      fontStyle: 'normal',
      letterSpacing: 1.5,
      paddingLeft: 5,
      display: 'block',
    },
  }
  return <div style={ style.logo }>
    <span style={ style.name }>Birgitt Kadler</span>
    <span style={ style.title }>Rechtsanwältin</span>
  </div>
}


// WEBPACK FOOTER //
// ./src/modules/logo.js